import _ from 'lodash'
import RepeatByHeaderCell from './repeat-by-header-cell'
import reportConstants from 'scoreboard/reports/report-constants'
import { LAST_STACK_ADDABLE_CLASS } from './table'

/**
 * Represents a cell within a top level repeat by stack layout
 */
class TopRepeatByHeaderCell extends RepeatByHeaderCell {

	constructor(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts = {}) {
		super(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts)
		this.position = reportConstants.REPEAT_BY_TOP_POSITION
	}

	/**
	 * @return {number} The row index of the cell
	 */
	rowIndex() {
		return 0
	}

	/**
	 * Returns the dom nodes that compose the complete side of the header cell
	 * stack. In this scenario this would be the header node of this row, the
	 * first/last header cell of the middle row (if it exists), and the
	 * first/last body nodes of the table body cells.  Since we're at the top
	 * of the breakdown there would not be any repeating columns to return
	 */
	sideDomNodes(left) {
		let headerRows = this.tableStack.rows()
		let headerSideNodes = []
		let sideMiddleCell = this
		if (headerRows.length == 3) {
			//if this stack has 2 breakdowns, get the side node of the middle row
			let middleRow = this.options.childCells
			sideMiddleCell = _.filter(middleRow, c => left ? c.firstChild : c.lastChild)[0]
			headerSideNodes.push(...sideMiddleCell.domNodes())
		}
		let bottomRow = sideMiddleCell.options.childCells
		let sidBottomCell = _.filter(bottomRow, c => left ? c.firstChild : c.lastChild)[0]
		headerSideNodes.push(...sidBottomCell.sideDomNodes())
		return [...this.domNodes(), ...headerSideNodes]
	}

	isSameLevel(cell) {
		return this.isSameRepeatBy(cell) && cell instanceof TopRepeatByHeaderCell
	}

	addIndex(addMarker) {
		if (addMarker.classList.contains(LAST_STACK_ADDABLE_CLASS) ||
			addMarker.classList.contains('addable-right')) {
			// else check to see if we're adding on the last most marker or if the
			// the button is on the right side of the column, if so add to the right
			// of the index
			return this.orderIndex + 1
		}
		return this.orderIndex
	}

}

export default TopRepeatByHeaderCell
TopRepeatByHeaderCell.__filename__ = 'reports/common/table/top-repeat-by-header-cell.js'
